import React from "react";
import ButtonPlusComp from "../components/buttonpluscomp";
import ListComp from "./listcomp";


function ListNestComp(props){
    const child = props.child
    const grandchild = props.grandchild
    const title = props.title
    const id = props.id
    const sendData = props.sendData
    const deleteData = props.deleteData
    const list = props.list

    const [isShow, setShowResults] = React.useState(false);
    const onClick = (event) => {event.preventDefault(); setShowResults(isShow ? false : true)};

    


    var grandchildcomp;
    const getById = (id) => {
        return child.find((item) => item.id === id);
      };
   if(grandchild){
        grandchildcomp = <div className="pl-5">
            {grandchild.filter((i) => (i.id_kategori === id)).map((grand)=>(
                < ListComp key = {
                    grand.id
                }
                grandchild = {
                    child.filter((i) => (i.id_hotkeys === grand.id))
                }
                title = {
                    grand.name
                }
                type = {
                    2
                }
                sendData = {sendData}
                deleteData={deleteData}
                list={list}
                />
            ))}
        </div>
    }

    return (
    <div className="">
        <ButtonPlusComp title={title} click={onClick} isClicked={isShow} />
        {isShow ? grandchildcomp : null}
        
    </div>)

}

export default ListNestComp